import {
    type Block,
    type Change,
    isTextRangeSelection,
    type TextRange,
    type Value,
} from '@gitbook/slate';

/**
 * Select the whole container content on first `mod+a` and the entire document on second.
 */
export function selectAllInContainerFirst(
    change: Change,
    getCurrentContainerRange: (value: Value, currentBlock: Block) => TextRange | null
): Change | undefined {
    const { value } = change;

    if (!isTextRangeSelection(value.selection)) {
        return;
    }

    const currentBlock = value.startBlock;
    if (!currentBlock) {
        return;
    }

    const containerRange = getCurrentContainerRange(value, currentBlock);
    if (!containerRange) {
        return;
    }

    if (!value.selection.hasMoved(containerRange)) {
        change.selectAllDocument().focus();
    } else {
        change.select(containerRange).focus();
    }

    return change;
}
